/*Customizations:
-  usata la customer satisfaction persoanlizzata per ausl piacenza, con le loro options e gestione obbligatorietà del campo commenti*/
import { FeedbackForm } from '@package/components';

const CustomerSatisfaction = () => {
  return <FeedbackForm />;
};
export default CustomerSatisfaction;
